import { CancelToken } from "axios";

import { IPlace, IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserAddressCollection {
  [IDataKeys.userAddress]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserAddressService {
  static createUserAddress = (address: Partial<IPlace>): Promise<IJSONAPIUserAddressCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_ADDRESSES,
          data: address,
        });
        resolve(response as IJSONAPIUserAddressCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_ADDRESS);
        reject({ error });
      }
    });

  static getUserAddresses = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserAddressCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_ADDRESSES,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserAddressCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_ADDRESS);
        reject({ error });
      }
    });

  static editUserAddress = (
    addressId: string,
    address: Partial<IPlace>
  ): Promise<IJSONAPIUserAddressCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_ADDRESS(addressId),
          data: address,
        });
        resolve(response as IJSONAPIUserAddressCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_ADDRESS);
        reject({ error });
      }
    });

  static deleteUserAddress = (addressId: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_ADDRESS(addressId),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_ADDRESS);
        reject({ error });
      }
    });
}
